import "./src/styles/global.css";

export const onClientEntry = () => {
  const ready = () => document.documentElement.classList.add("fonts-ready");
  if (document.fonts?.ready) {
    document.fonts.ready.then(ready);
  }
  setTimeout(ready, 2000);
};
